import { apiRequest } from "../lib/apiClient";
import type { GiftCardIssueRequest, GiftCardOut, GiftCardRedeemRequest } from "./types";

/** `GET /gift-cards/{code}` — lookup by code string, any authenticated user. */
export async function getGiftCard(accessToken: string, code: string): Promise<GiftCardOut> {
  return apiRequest<GiftCardOut>(`/gift-cards/${encodeURIComponent(code)}`, { accessToken });
}

/** `POST /gift-cards` — OWNER/BRANCH_MANAGER only ("minting arbitrary store-credit
 * liability"). */
export async function issueGiftCard(accessToken: string, body: GiftCardIssueRequest): Promise<GiftCardOut> {
  return apiRequest<GiftCardOut>("/gift-cards", { method: "POST", accessToken, body });
}

/** `POST /gift-cards/{code}/redeem` — any authenticated user (bounded by the card's own
 * guarded balance decrement). */
export async function redeemGiftCard(accessToken: string, code: string, body: GiftCardRedeemRequest): Promise<GiftCardOut> {
  return apiRequest<GiftCardOut>(`/gift-cards/${encodeURIComponent(code)}/redeem`, { method: "POST", accessToken, body });
}
